import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, tap, catchError, finalize, throwError } from 'rxjs';
import { LoaderService } from '../services/loader.service';
import { ToastrMessageService } from '../services/toastr.service';

@Injectable({
  providedIn: 'root'
})
export class LoaderInterceptor implements HttpInterceptor {

  private requests: HttpRequest<any>[] = [];

  constructor(
    private loaderService: LoaderService,
    private router: Router,
    private toastrService: ToastrMessageService
  ) {}

  private removeRequest(req: HttpRequest<any>) {
    const index = this.requests.indexOf(req);
    if (index >= 0) {
      this.requests.splice(index, 1);
    }
    if(this.requests.length > 0){
      this.loaderService.show();
    }else{
      this.loaderService.hide();
    }
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const skipLoader = req.headers.get('skipLoader') === 'true';

    if (!skipLoader && req.method !== 'PATCH') {
      this.loaderService.show();
    }

    return next.handle(req).pipe(

      // ✅ handle successful responses
      tap(event => {
        if (event instanceof HttpResponse) {

          if (event.body?.status === 'ERROR') {
            if (event.body.message) {
              this.toastrService.triggerNotification(event.body.message, 'error');
            } else if (event.body.actionResult?.errors) {
              const errors = event.body.actionResult.errors
                .map(e => e.description)
                .join('<br/>');
              this.toastrService.triggerNotification(errors, 'error');
            }
          }
        }
      }),

      // ✅ handle errors
      catchError(err => {

        if (err.status === 401 && !err.url?.includes('graph.microsoft.com')) {
          const message =
            err.error?.message ||
            (err.error?.path === 'auth/login'
              ? 'Invalid email or password.'
              : 'Please login to access system.');

          this.toastrService.triggerNotification(message, 'error');
          sessionStorage.setItem('lastURL', window.location.href);
          this.router.navigate(['/login']);
        }
        else if (err.status === 400) {
          this.toastrService.triggerNotification('Invalid Request Parameter.', 'error');
        }
        else if (err.status === 403) {
          this.toastrService.triggerNotification(
            'You are not authorized user, to see this page.',
            'error'
          );
          this.router.navigate(['/']);
        }
        else if (err.status === 404) {
          this.toastrService.triggerNotification(
            'Oops, something went wrong, please try again later.',
            'error'
          );
        }

        return throwError(() => err);
      }),

      finalize(() => {
        if (!skipLoader && req.method !== 'PATCH') {
          this.removeRequest(req);
        }
      })
    );
  }
}
